<template>
	<div v-if="approved">
		<a @click.prevent="toggle" class="btn btn-success ps-3 pe-4 rounded-pill" href="#">
			<i class="fe fe-check-circle ms-1 me-2"></i> Approved
		</a>
	</div>
	<div v-else>
		<a @click.prevent="toggle" class="btn btn-outline-success ps-3 pe-4 rounded-pill" href="#">
			<i class="fe fe-circle me-1 ms-2"></i> Approve
		</a>
	</div>
</template>

<script>
	export default {

		props: ['model', 'endpoint'],

		emits: ['approved'],

		data() {
			return {
				approved: this.model.approved_at == null ? false : true,
			};
		},

		methods: {
			toggle() {
				axios.get(this.endpoint)
					.then((response) => {
						this.approved = ! this.approved;
						this.$emit('approved');
					})
					.catch((error) => {
						console.error(error);
					});
			}
		}

	}
</script>
